import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { BranchCategoryModel } from "./branch-category-data.model";

export class BranchCategoryGridModel extends BranchCategoryModel { }

export class BranchCategoryListingModel extends GridModel<BranchCategoryGridModel> { }

export class BranchCategoryGridPostParams extends GridPostParams {
    search_text: string = ''
}
